<div class="tw:flex tw:w-full tw:flex-col tw:items-center tw:justify-center tw:px-6 tw:py-16">
    @if (waitingForTeyaTerminal()) {
        <div class="tw:p-4">
            <app-loader />
        </div>

        <div class="tw:text-center">
            <div class="tw:text-sm tw:font-semibold">
                {{ 'SHARED.SIMPLE_PAYMENT_MODAL.waitingPayment' | translate }}
            </div>
            <div class="tw:mt-0.5 tw:text-sm tw:text-neutral-500">{{ unchargedTeyaAmount() / 100 | merchantCurrency }}</div>
        </div>

        <div class="tw:py-4">
            <app-button size="sm" type="secondary" [disabled]="cancellingTeyaPayment()" (clickEvent)="cancelTeyaTerminal()">{{
                'GENERAL.cancel' | translate
            }}</app-button>
        </div>
    } @else {
        <div class="tw:mb-4 tw:flex tw:h-16 tw:w-16 tw:items-center tw:justify-center tw:rounded-full tw:bg-success-100">
            <i class="material-icons icon tw:!text-success-600 tw:!text-4xl">check</i>
        </div>

        <div class="tw:mb-6 tw:text-center">
            <h6 class="tw:h6 tw:mb-2">{{ 'INVOICE_SUCCESS.success' | translate }}</h6>
            @if (completeInvoiceData()?.invoiceReference) {
                <div class="tw:text-sm tw:font-medium tw:text-neutral-500">
                    {{ 'GENERAL.invoice' | translate }} {{ completeInvoiceData()?.invoiceReference || '-' }}
                </div>
            }
        </div>

        @if (completeInvoiceData()?.invoiceEmissionFailed) {
            <div class="tw:mb-4 tw:w-full tw:max-w-md">
                <app-alert type="warning"
                    [title]="'INVOICE_SUCCESS.invoiceFailedTitle' | translate"
                    [msg]="'INVOICE_SUCCESS.invoiceFailedDescription' | translate"
                 />
            </div>
        }

        @if (teyaPaymentFailed()) {
            <div class="tw:mb-4 tw:w-64 tw:max-w-md tw:flex-col tw:justify-center tw:align-center tw:bg-warning-100 tw:p-4 tw:rounded-lg">
                <div class="tw:text-center tw:font-bold">{{ 'INVOICE_SUCCESS.paymentFailedTitle' | translate }}</div>
                <div class="tw:text-center tw:text-sm tw:my-2">{{ 'INVOICE_SUCCESS.paymentFailedDescription' | translate }}</div>
                <div class="tw:w-full tw:flex tw:justify-center tw:mt-2">
                    <app-button size="sm" type="primary" extraClass="tw:!bg-warning-500" (clickEvent)="sendSaleToTeyaTerminal()">{{
                                'GENERAL.retry' | translate
                    }}</app-button>
                </div>
            </div>
        }

        <div class="tw:flex tw:w-full tw:flex-col tw:items-center tw:gap-2 tw:p-4">
            <button class="btn btn-md btn-primary tw:w-64" type="button" (click)="goToStart()">
                {{ 'INVOICE_SUCCESS.conclude' | translate }}
            </button>

            @if (completeInvoiceData()?.invoicePdfUrl) {
                <button class="btn btn-md btn-secondary tw:w-64" type="button" (click)="emailInvoice(completeInvoiceData())">
                    <i class="material-icons icon tw:!text-primary-400 tw:mr-2">mail_outline</i>
                    {{ 'INVOICE_SUCCESS.emailInvoice' | translate }}
                </button>

                <button class="btn btn-md btn-secondary tw:w-64" type="button" (click)="printInvoice(completeInvoiceData())">
                    <i class="material-icons icon tw:!text-primary-400 tw:mr-2">print</i>
                    {{ 'INVOICE_SUCCESS.printInvoice' | translate }}
                </button>

                <div class="invoice-success-more-options" dropdown placement="bottom">
                    <button dropdownToggle class="btn btn-md btn-secondary tw:w-64" type="button">
                        {{ 'INVOICE_SUCCESS.moreOptions' | translate }}
                        <i class="material-icons icon">arrow_drop_down</i>
                    </button>
                    <ul *dropdownMenu class="dropdown-menu">
                        @if (completeInvoiceData()?.invoiceTicketPdfUrl) {
                            <li>
                                <a class="dropdown-item" (click)="printTicket(completeInvoiceData())">
                                    <i class="material-icons icon">receipt</i>
                                    {{ 'INVOICE_SUCCESS.printTicket' | translate }}
                                </a>
                            </li>
                        }
                        <li>
                            <a class="dropdown-item" (click)="downloadInvoice(completeInvoiceData())">
                                <i class="material-icons icon">file_download</i>
                                {{ 'INVOICE_SUCCESS.downloadInvoice' | translate }}
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" (click)="openSaleDetails()">
                                <i class="material-icons icon">receipt_long</i>
                                {{ 'INVOICE_SUCCESS.openSaleDetails' | translate }}
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" (click)="goToSales()">
                                <i class="material-icons icon">shopping_cart</i>
                                {{ 'INVOICE_SUCCESS.goToSales' | translate }}
                            </a>
                        </li>
                    </ul>
                </div>
            } @else {
                <button class="btn btn-md btn-secondary tw:w-64" type="button" (click)="openSaleDetails()">
                    <i class="material-icons icon tw:!text-primary-400 tw:mr-2">receipt_long</i>
                    {{ 'INVOICE_SUCCESS.openSaleDetails' | translate }}
                </button>

                <button class="btn btn-md btn-secondary tw:w-64" type="button" (click)="goToSales()">
                    <i class="material-icons icon tw:!text-primary-400 tw:mr-2">shopping_cart</i>
                    {{ 'INVOICE_SUCCESS.goToSales' | translate }}
                </button>
            }
        </div>
    }
</div>
